// extracted by mini-css-extract-plugin
export default {"root":"EditInstanceConfigForm_root__bzRCQ","form":"EditInstanceConfigForm_form__K0cNa","after":"EditInstanceConfigForm_after__XZRGw"};